<template>
    <div class="pop_bg" v-if="showPop">
        <div class="pop_body">
            <div class="pop_head">
                <span class="border_green"></span>
                <span class="pop_tit" v-text="title"></span>
                <div class="pop_close" @click="poptoggle(false)">
                    <img src="./img/popup_close.svg" alt="">
                </div>
            </div>
            <div class="pop_content">
                <slot></slot>
            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        name: 'pop-window',
        data() {
            return {
                showPop: false,
            }
        },
        props:[
            "title"
        ],
        methods: {
            goTop(){
                window.scrollTo(0,0)
            },
            poptoggle(boo){
                this.showPop = boo
            }
        },
        created() {},
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    $cl_green: #50BBE5;
    $cl_dark: #444444;
    
    .pop_bg{
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.6);
        top: 0;
        left: 0;
        z-index: 10;
        animation: fadeIn 0.3s forwards;
        .pop_body{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            background: #ffffff;
            border-radius: .12rem;
            width: 3.36rem;
            .pop_head{
                padding: .2rem;
                height: .6rem;
                box-sizing: border-box;
                border-bottom: 1px solid #dddddd;
                .border_green{
                    display: block;
                    float: left;
                    width: 0.04rem;
                    height: .2rem;
                    background: $cl_green;
                    border-radius: .02rem;
                    margin-right: .1rem;
                }
                .pop_tit{
                    display: block;
                    float: left;
                    font-size: .16rem;
                    color: $cl_dark;
                }
                .pop_close{
                    display: block;
                    float: right;
                    width: .2rem;
                    height: .2rem;
                    img{
                        display: block;
                        width: 100%;
                    }
                }
            }
            .pop_content{
                padding: .2rem;
            }
        }
        
    }
    .pop-lay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.6);
    .pop_body{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background: #ffffff;
        border-radius: .12rem;
        width: 3.36rem;
        .pop_head{
            padding: .2rem;
            height: .6rem;
            box-sizing: border-box;
            border-bottom: 1px solid #dddddd;
            .border_green{
                display: block;
                float: left;
                width: 0.04rem;
                height: .2rem;
                background: $cl_green;
                border-radius: .02rem;
                margin-right: .1rem;
            }
            .pop_tit{
                display: block;
                float: left;
                font-size: .16rem;
                color: $cl_dark;
            }
            .pop_close{
                display: block;
                float: right;
                width: .2rem;
                height: .2rem;
                img{
                    display: block;
                    width: 100%;
                }
            }
        }
        .pop_content{
            padding: .2rem;
        }
    }
}

.block_btn {
    display: block;
    text-decoration: none;
    height: .4rem;
    border-radius: .2rem;
    text-align: center;
    line-height: .4rem;
    font-size: .14rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.border_btn {
    border: 1px solid #2DA2D4;
    color: #2DA2D4;
}

.fill_btn {
    background: #2DA2D4;
    color: #ffffff;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
